module.exports = __webpack_public_path__ + "img/baoshan.997d1ed7.jpg";